import { render, staticRenderFns } from "./ModalImages.vue?vue&type=template&id=b831dfc8"
import script from "./ModalImages.vue?vue&type=script&lang=js"
export * from "./ModalImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports